module.exports = __webpack_public_path__ + "img/buddha.137d5d70.png";